<template>
  <div class="container">
    <el-row class="header-title">
      <el-button
        type="primary"
        icon="el-icon-plus"
        size="mini"
        @click.stop="addClassDish"
      ></el-button>
      <el-button
        :type="combineMode ? 'danger' : 'primary'"
        size="mini"
        @click.stop="emitCombineMode"
      >
        {{ !combineMode ? "碗碟合并" : "取消合并" }}
      </el-button>
      <el-button
        :type="copyMode ? 'danger' : 'primary'"
        size="mini"
        @click.stop="emitCopyMode"
      >
        {{ !copyMode ? "碗碟拷贝" : "取消拷贝" }}
      </el-button>
      &nbsp;&nbsp;&nbsp;
      <el-badge class="mark" :value="detectedByDishList.length">
        <el-tag size="mini" type="success">碗碟</el-tag>
      </el-badge>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <el-badge class="mark" :value="detectedByContentList.length">
        <el-tag  size="mini" type="success">内容</el-tag>
      </el-badge>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <el-input
        v-model="search_text"
        placeholder="快速搜索"
        size="mini"
        class="btn-item"
      ></el-input>
    </el-row>
    <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane label="碗碟识别" name="dishMode">
        <el-row :gutter="10" style="height: 90vh; overflow-y: scroll">
          <dish-card class="dish-card"
                     :class="{
                     'dish-card-combine': combineMode,
                     'dish-card-copy': copyMode
                      }"
                     @delete="deleteClassDish"
                     @edit="editClassDish"
                     :dish="dish" v-for="(dish, idx) in detectedByDishList"
                     :key="idx">
            <template v-slot:btn>
              <!--<el-button type="text" size="mini" @click="combineDish(dish)">选择</el-button>-->
              <el-tag type="danger" v-if="unCombineDishClassId.indexOf(dish.class_id) !== -1">已选</el-tag>
              <el-button
                class="btn"
                v-if="combineMode && unCombineDishClassId.indexOf(dish.class_id) === -1"
                type="text"
                @click="combineDish(dish)"
              >选择
              </el-button
              >
              <el-button
                class="btn"
                v-if="copyMode"
                type="text"
                @click="copyDish(dish)"
              >拷贝
              </el-button>
            </template>
          </dish-card>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="内容识别" name="contentMode">
        <el-row :gutter="10">
          <dish-card class="dish-card"
                     :class="{
                     'dish-card-combine': combineMode,
                     'dish-card-copy': copyMode
                      }"
                     @delete="deleteClassDish"
                     @edit="editClassDish"
                     :dish="dish" v-for="dish in detectedByContentList"
                     :key="dish.class_id">
            <template v-slot:btn>
              <!--<el-button type="text" size="mini" @click="combineDish(dish)">选择</el-button>-->
              <el-tag type="danger" v-if="unCombineDishClassId.indexOf(dish.class_id) !== -1">已选</el-tag>
              <el-button
                class="btn"
                v-if="combineMode && unCombineDishClassId.indexOf(dish.class_id) === -1"
                type="text"
                @click="combineDish(dish)"
              >选择
              </el-button
              >
              <el-button
                class="btn"
                v-if="copyMode"
                type="text"
                @click="copyDish(dish)"
              >拷贝
              </el-button>
            </template>
          </dish-card>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      v-if="classDishMetashow"
      title="请输入碗碟信息"
      class="dialog"
      :visible.sync="classDishMetashow"
    >
      <el-form ref="form" :model="currentDish" label-width="120px">
        <el-form-item label="碗碟名称(碗碟库)" prop="dish_native_name">
          <el-input
            style="width: 300px"
            size="mini"
            v-model="currentDish.dish_native_name"
            placeholder="请输入碗碟在碗碟库中的名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="dish_native_name">
          <el-input
            style="width: 300px"
            size="mini"
            v-model="currentDish.dish_desc"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <el-form-item label="类别" prop="dish_type">
          <el-select
            filterable
            allow-create
            size="mini"
            v-model="currentDish.classify"
            placeholder="请选择类别"
          >
            <el-option
              v-for="type in classType"
              :key="type"
              :label="type"
              :value="type"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="识别类型" prop="dish_type">
          <el-select
            size="mini"
            v-model="currentDish.dish_type"
            placeholder="请选择识别类型"
          >
            <el-option
              v-for="item in dish_typeOptions"
              :key="item.index"
              :label="item.type"
              :value="item.index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="示例图片" prop="dish_image_url">
          <el-upload
            action
            :show-file-list="false"
            :http-request="handleImageUpload"
            list-type="picture-card"
            class="upload"
          >
            <div class="image-wrapper" v-if="currentDish.dish_image_url">
              <img
                class="image-item avatar"
                :src="currentDish.dish_image_url"
              />
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper">
        <el-button type="danger" @click="cancelEdit">取消</el-button>
        <el-button type="primary" @click="confirmEdit">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="请选择需要保留的碗碟, 另一碗碟将在合并后删除"
      :visible.sync="combineDialogShow"
      width="30%"
    >
      <div
        class="image-item-wrapper"
        v-for="(dish, idx) in unCombineDishes"
        :key="dish.class_id"
      >
        <el-badge class="mark" :value="dish.img_count"/>
        <img :src="dish.dish_image_url" alt class="image-item"/>
        <el-button
          type="success"
          mini="size"
          @click="selectedStay(idx)"
          :disabled="stayButtonShow"
          size="mini"
        >保留
        </el-button
        >
        <el-tag
          type="success"
          v-if="
            combineClassId.old_class_id &&
             combineClassId.old_class_id === dish.class_id"
        >已保留
        </el-tag
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="combineDialogShow = false">取 消</el-button>
        <el-button type="primary" @click="comfirmCombine">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="此碗碟和以下餐厅有关联"
      :visible.sync="binCanteenListDialogShow"
      width="50%"
    >
      <el-table :data="bindCanteenList" style="width: 100%">
        <el-table-column
          header-align="center"
          align="center"
          prop="eatery_name"
          label="食堂"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="canteen_name"
          label="餐厅"
        >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="removeDishFromCanteen(scope)"
              :disabled="scope.row.unbind === true"
            >{{
              scope.row.unbind === true ? "已解除" : "解除关联"
              }}
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="binCanteenListDialogShow = false"
        >取消删除</el-button
        >
        <el-button size="mini" type="danger" @click="unBindAllAndDelete"
        >全部取消关联并删除</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import AliOss from 'ali-oss';
  import pinyinMatch from 'pinyin-match';
  import {
    apiAddClass,
    apiClassifyQuery,
    apiCombineDishes,
    apiCopyClassDish,
    apiDeleteClass,
    apiDeleteRelatedClass,
    apiEditClassDish,
    apiGetBindCanteenListByClassId,
    apiGetImageRegions,
    apiGetImgCountByClassId
  } from '@/api';
  import {mapActions, mapGetters, mapMutations} from 'vuex';
  import {errorMessage, successMessage} from '@/lib/msg';
  import util from '@/lib/util';
  import dishCard from './dishCard';

  export default {
    name: "dishModelManagement",
    components: {
      dishCard
    },
    data() {
      return {
        classType: '',
        btnShow: false,
        deletingClassDishClassId: "",
        binCanteenListDialogShow: false,
        bindCanteenList: [],
        buttonShow: false,
        activeName: "dishMode",
        copyDialogShow: false,
        copyMode: false,
        search_text: "",
        stayButtonShow: false,
        combineClassId: {},
        combineDialogShow: false,
        unCombineDishes: [],
        combineMode: false,
        currentDish: {
          classify: '碗碟',
          dish_type: "1",
          dish_image_url: "",
          dish_native_name: "",
          dish_desc: ""
        },
        fileReader: null,
        dish_typeOptions: [
          {
            type: "碗碟识别模式",
            index: "1"
          },
          {
            type: "内容识别模式",
            index: "2"
          }
        ],
        classDishMetashow: false
      };
    },
    mounted() {
      this.fileReader = new FileReader();
      this.setSubTitle("碗碟库管理");
      this.getClassify();
      this.setAllClassList();
    },
    methods: {
      ...mapMutations(["setSubTitle", "emitLoading", "removeLoading"]),
      ...mapActions(["setAllClassList"]),
      async getClassify () {
        try {
          const res = await apiClassifyQuery();
          this.classType = res.classify;
          console.log(res);
        } catch (e) {
          console.log(e);
          this.$message.error('获取类型列表失败' + e.message);
        }
      },
      async unBindAllAndDelete() {
        let list = this.bindCanteenList;
        //   for (let i = 0; i < list.length; i++) {
        //     let row = list[i];
        //     await this.removeDishFromCanteen({row, $index: i});
        // }
        let promises = list.map((row, $index) =>
          this.removeDishFromCanteen({row, $index})
        );
        await Promise.all(promises);
        // console.log('121221121');
        // this.$alert('解除成功')
        try {
          await apiDeleteClass(this.deletingClassDishClassId);
          this.$message.warning("删除成功");
          this.binCanteenListDialogShow = false;
          // this.setAllClassList();
        } catch (e) {
          this.binCanteenListDialogShow = false;
          this.$message.error("删除失败");
        }
      },
      async removeDishFromCanteen(scope) {
        let {row, $index} = scope;
        let canteen_id = row.canteen_id;
        try {
          await apiDeleteRelatedClass({
            canteen_id,
            class_id: this.deletingClassDishClassId,
            apiKey: this.userinfo().api_key
          });
          this.$set(this.bindCanteenList[$index], "unbind", true);
          // this.getBindCanteenListByClassId(row.canteen_id);
          console.log("saaaaaaaa");
          this.$message.warning("解除成功");
        } catch (e) {
          this.$message.error("解除失败" + e.message);
        }
      },
      emitCombineMode() {
        this.copyMode = false;
        this.combineMode = !this.combineMode;
        if (this.combineMode === false) {
          this.unCombineDishes = [];
        }
      },
      emitCopyMode() {
        this.combineMode = false;
        this.copyMode = !this.copyMode;
      },
      copyDish(dish) {
        this.$confirm("是否拷贝该碗碟?", "提示", {
          confirmButtonText: "确认拷贝",
          cancelButtonText: "取消"
        })
          .then(async () => {
            this.emitLoading();
            try {
              await apiCopyClassDish(dish.class_id, this.apiKey);
              this.setAllClassList();
              this.removeLoading();
              this.copyMode = false;
              this.$message.warning("拷贝成功");
            } catch (e) {
              console.log(e);
              this.removeLoading();
              this.copyMode = false;
              this.$message.error("拷贝失败");
            }
            // let newDish = this.$_.cloneDeep(dish);
            // let image = newDish.dish_image_url;
            // loadXHR(image).then(blob => {
            //   let storeAs = 'copy' + new Date().getTime();
            //   this.createOssClient();
            //   this.client.put(storeAs, blob).then(async (res) => {
            //     this.$set(newDish, 'dish_image_url', res.url);
            //     try {
            //       await apiAddClass({
            //         dish_img_url: newDish.dish_image_url,
            //         dish_type: newDish.dish_type,
            //         dish_belong: '0'
            //       });
            //       this.copyMode = false;
            //       this.setAllClassList();
            //       this.removeLoading();
            //       this.$message.warning('碗碟拷贝成功');
            //     } catch (e) {
            //       console.log(e);
            //       this.removeLoading();
            //       this.$message.error('碗碟拷贝失败');
            //       this.copyMode = false;
            //     }
            //     ;
            //   }).catch(e => {
            //     console.log(e);
            //     this.$message.error('上传阿里云失败');
            //   });
            // }).catch((e) => {
            //   console.log(e);
            //   this.$message.error('下载图片失败');
            // });
          })
          .catch(() => {
          });
      },
      async getBindCanteenListByClassId(class_id) {
        try {
          let res = await apiGetBindCanteenListByClassId(class_id);
          this.bindCanteenList = res.canteen_info_list;
        } catch (e) {
          this.$message.error("查询失败" + e.message);
          return [];
        }
      },
      async deleteClassDish(row) {
        let class_id = row.class_id;
        this.deletingClassDishClassId = class_id;
        await this.getBindCanteenListByClassId(class_id);
        if (this.bindCanteenList.length === 0) {
          this.$confirm("此碗碟没有关联餐厅可以直接删除?", "提示", {
            confirmButtonText: "删除",
            cancelButtonText: "取消删除"
          })
            .then(async () => {
              try {
                await apiDeleteClass(row.class_id);
                this.$message.warning("删除成功");
                this.setAllClassList();
              } catch (e) {
                this.$message.error("删除失败" + e.message);
              }
            })
            .catch(() => {
              this.$message.error("您已取消删除");
            });
        } else {
          this.binCanteenListDialogShow = true;
        }
        // try {
        // let confirmDelete = await apiConfirmDeleteClass(row.class_id);

        //   if (confirmDelete === true) {
        //
        //     // 无关联可直接删除
        //     // this.$confirm("是否删除?", "提示", {
        //     //   confirmButtonText: "删除",
        //     //   cancelButtonText: "取消删除"
        //     // })
        //     //   .then(async () => {
        //     //     try {
        //     //       await apiDeleteClass(row.class_id);
        //     //       successMessage("删除成功");
        //     //       this.setAllClassList();
        //     //     } catch (e) {
        //     //       errorMessage("删除失败");
        //     //     }
        //     //   })
        //     //   .catch(() => {
        //     //     errorMessage("您已取消删除");
        //     //   });
        //   } else if (confirmDelete === false) {
        //     this.$confirm("该碗碟已和餐厅关联, 是否删除?", "提示", {
        //       confirmButtonText: "删除",
        //       cancelButtonText: "取消删除"
        //     })
        //       .then(async () => {
        //         try {
        //           await apiDeleteClass(row.class_id);
        //           successMessage("删除成功");
        //           this.setAllClassList();
        //         } catch (e) {
        //           errorMessage("删除失败");
        //         }
        //       })
        //       .catch(() => {
        //         errorMessage("您已取消删除");
        //       });
        //   }
        // } catch (e) {}
      },
      showAddModal() {
        this.addModalShow = true;
      },
      handleImageUpload(options) {
        this.$confirm("是否进行切割?", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否"
        })
          .then(() => {
            this.handleImageUploadWithCliping(options);
          })
          .catch(() => {
            this.handleUploadWithoutCliping(options);
          });
      },
      handleUploadWithoutCliping(options) {
        let file = options.file;
        let fileType = file.name.split(".")[1];
        let storeAs = new Date().getTime() + "." + fileType;
        this.createOssClient();
        this.client.put(storeAs, file).then(res => {
          this.$set(this.currentDish, "dish_image_url", res.url);
        });
      },
      handleImageUploadWithCliping(options) {
        const resizeImage = function (settings, config) {
          let file = settings.file;
          let maxSize = settings.maxSize;
          let reader = new FileReader();
          let image = new Image();
          let canvas = document.createElement("canvas");
          let dataURItoBlob1 = function (dataURI) {
            let bytes =
              dataURI.split(",")[0].indexOf("base64") >= 0
                ? atob(dataURI.split(",")[1])
                : unescape(dataURI.split(",")[1]);
            let mime = dataURI
              .split(",")[0]
              .split(":")[1]
              .split(";")[0];
            let max = bytes.length;
            let ia = new Uint8Array(max);
            for (let i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
            return new Blob([ia], {type: mime});
          };
          let resize = function () {
            let width = image.width;
            let height = image.height;
            // console.log(image);
            height *= config.h;
            width *= config.w;
            // console.log(image.width, image.height);
            canvas.width = width;
            canvas.height = height;
            canvas
              .getContext("2d")
              .drawImage(
                image,
                config.x * image.width,
                config.y * image.height,
                width,
                height,
                0,
                0,
                width,
                height
              );
            let dataUrl = canvas.toDataURL("image/jpeg");
            // console.log(dataUrl);
            return dataURItoBlob1(dataUrl);
          };
          return new Promise(function (resolve, reject) {
            if (!file.type.match(/image.*/)) {
              return reject(new Error("Not an image"));
            }
            reader.onload = function (readerEvent) {
              image.onload = function () {
                resolve(resize());
              };
              image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
          });
        };
        this.emitLoading();
        let file = options.file;
        // this.getImageRegion(file);
        // console.log(file);

        if (file) {
          this.fileReader.readAsDataURL(file);
        }
        this.fileReader.onload = async () => {
          try {
            // console.log(base64Str);
            let fileType = file.name.split(".")[1];
            let storeAs = new Date().getTime() + "." + fileType;
            this.createOssClient();
            let base64Str = this.fileReader.result;
            let blob = util.dataURItoBlob(base64Str);
            let regions = await apiGetImageRegions(base64Str);
            if (regions && regions.length > 0) {
              regions = JSON.parse(regions, null, 4);
            } else {
              this.removeLoading();
              return;
            }
            resizeImage(
              {
                file: blob
              },
              regions[0]
            )
              .then(res => {
                if (res) {
                  this.client.put(storeAs, res).then(res => {
                    this.$set(this.currentDish, "dish_image_url", res.url);
                  });
                  this.removeLoading();
                } else {
                  errorMessage("切割图片出错");
                  this.removeLoading();
                }
              })
              .catch(e => {
                this.removeLoading();
              });
          } catch (e) {
            this.removeLoading();
            console.log(e);
          }
        };
      },
      getImageRegion(file) {
        // let reader = new FileReader();
        // reader.readAsArrayBuffer(file);
        // reader.onload = function () {
        //
        // }s
        console.log(file);
      },
      createOssClient() {
        let options = {
          region: "oss-cn-shanghai",
          accessKeyId: "LTAI8UIymyrGyBJo",
          accessKeySecret: "TgUaBCFsjkoJqHMDk3iqcVebdW4y5z",
          bucket: "zx-text"
        };
        this.client = new AliOss(options);
      },
      editClassDish(row) {
        // console.log(row);
        this.classDishMetashow = true;
        this.currentDish = row;
      },
      addClassDish() {
        this.currentDish.dish_type =
          this.activeName === "contentMode" ? "2" : "1";
        this.classDishMetashow = true;
      },
      selectedStay(idx) {
        this.$confirm("确定保留此碗碟?", "再次提示", {
          type: "warning",
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
          .then(() => {
            let old_class_id = this.unCombineDishes[idx].class_id;
            let new_class_id =
              idx === 0
                ? this.unCombineDishes[1].class_id
                : this.unCombineDishes[0].class_id;
            this.$set(this.combineClassId, "old_class_id", old_class_id);
            this.$set(this.combineClassId, "new_class_id", new_class_id);
            this.stayButtonShow = true;
          })
          .catch(() => {
            this.$message.error("已取消");
          });
      },
      async comfirmCombine() {
        try {
          await apiCombineDishes(this.combineClassId);
          this.combineDialogShow = false;
          this.$confirm.success("合并成功");
        } catch (e) {
          this.$confirm.error("合并出错");
          console.log(e);
        }
      },
      async combineDish(dish) {
        if (this.unCombineDishes.length === 2) {
          return this.$message.error("已选择了两个碗碟");
        }
        let res = this.$_.find(this.unCombineDishes, a => {
          return a.class_id === dish.class_id;
        });
        if (res) {
          return this.$message.error("该碗碟已选择");
        } else {
          let count = 0;
          try {
            let r = await apiGetImgCountByClassId(dish.class_id);
            count = r.img_count;
          } catch (e) {
            console.log(e);
            this.$message.error("查询图片个数失败");
            count = 0;
          }
          this.$set(dish, "img_count", count);
          this.unCombineDishes.push(dish);
        }
      },
      async confirmEdit() {
        if (!this.currentDish.class_id) {
          // 添加逻辑
          this.classDishMetashow = false;
          try {
            this.emitLoading();
            await apiAddClass({
              classify: this.currentDish.classify,
              dish_native_name: this.currentDish.dish_native_name,
              dish_desc: this.currentDish.dish_desc,
              dish_img_url: this.currentDish.dish_image_url,
              dish_type: this.currentDish.dish_type,
              dish_belong: "0"
            });
            this.setAllClassList();
            this.removeLoading();
          } catch (e) {
            console.log(e);
            this.$message.error('添加失败' + e.message);
            this.removeLoading();
          }
        } else {
          // 修改逻辑
          try {
            // 提交修改的数据
            await apiEditClassDish({
              class_meta_info: this.currentDish,
              class_id: this.currentDish.class_id,
              apiKey: this.userinfo().api_key
            });
            this.classDishMetashow = false;
            this.setAllClassList();
            this.getClassify();
            successMessage("修改成功");
          } catch (e) {
            this.classDishMetashow = false;
            errorMessage("修改失败");
          }
        }
      },
      cancelEdit() {
        this.classDishMetashow = false;
      },
      isSelected(dish) {
        // const class_id
        let res = this.$_.find(this.unCombineDishes, a => dish.class_id === a.class_id);
        // console.log(res);
        return !!res;
      }
    },
    computed: {
      ...mapGetters(["allClassList", "userinfo"]),
      formLabelWidth() {
        return "100px";
      },
      unCombineDishClassId() {
        return this.unCombineDishes.map(a => a.class_id);
      },
      // 快速搜索筛选
      classListBySearchFilter() {
        let search = this.search_text;
        let list = this.allClassList;
        if (search !== "") {
          return list.filter(a => {
            let res = pinyinMatch.match(
              a.dish_desc + "," + a.dish_native_name,
              search
            );
            return res.length > 0;
            // return canteen['canteen_name'].indexOf(search) !== -1 || canteen['eatery_name'].indexOf(search) !== -1;
          });
        } else {
          return list;
        }
      },
      // 碗碟识别模式
      detectedByDishList() {
        return (
          this.classListBySearchFilter.length > 0 &&
          this.classListBySearchFilter.filter(item => item.dish_type === "1")
        );
      },
      // 内容识别模式
      detectedByContentList() {
        return (
          this.classListBySearchFilter.length > 0 &&
          this.classListBySearchFilter.filter(item => item.dish_type === "2")
        );
      }
    },
    watch: {
      unCombineDishes: {
        handler(val) {
          if (val.length > 1) {
            this.combineDialogShow = true;
          }
        }
      },
      classDishMetashow(val) {
        if (!val) {
          this.currentDish = {
            dish_type: "1",
            dish_image_url: ""
          };
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
  .container {
    position: relative;

    .dish-card {
      &.dish-card-combine {
        background-color: #ccc;
      }

      &.dish-card-copy {
        background-color: #ccc;
      }

      &.selected {
        background-color: #fff;
      }
    }

    .header-title {
      position: absolute;
      left: 150px;
      top: -35px;
      width: 500px;

      .btn-item {
        width: 200px;
        position: absolute;
        margin-left: 15px;
      }
    }

    .dialog {
      .btn-wrapepr {
        text-align: right;
      }
    }

    .box-card {
      &.box-card-combine {
        background-color: #ccc;
      }

      &.box-card-copy {
        background-color: #ccc;
      }

      &.selected {
        background-color: #fff;
      }

      .image-wrapper {
        margin: 0 auto;
        width: 100px;
        height: 100px;
      }

      .image-item {
        width: auto;
        height: auto;
        max-height: 100%;
        max-width: 100%;
      }
    }

    .upload {
      .image-wrapper {
        margin: 0 auto;
        width: 100%;
        height: 100%;
      }

      .image-item {
        width: auto;
        height: auto;
        max-height: 100%;
        max-width: 100%;
      }
    }

    .image-item-wrapper {
      vertical-align: top;
      display: inline-block;
      margin: 0 auto;
      width: 100px;
      height: 100px;
    }

    .image-item {
      width: auto;
      height: auto;
      max-height: 100%;
      max-width: 100%;
    }

    .class-dish-wrapper {
      display: inline-block;
      width: 100px;
      height: 100px;
    }

    .btn-wrapper {
      text-align: right;
    }

    .dish-card {
      width: 150px;
      height: 200px;
      margin: 0 10px 10px 0;
      display: inline-block;
      vertical-align: top;
    }

    .btn {
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
</style>
